import { __CLASS_FORM_V3__, __CLASS_CSR_CMP__ } from "@/const/ssrClass";
import { useParentEl } from "@/hooks/common/useParentEl";
import { storeToRefs } from 'pinia';
import { getStore } from "@/store/index";

// 获取当前节点对应的表单节点 form-v3
export const useCurrentFormV3El = (el) => {
    return useParentEl(el, __CLASS_FORM_V3__)
}
// 获取当前表单下所有csr组件的状态
export const useCurrentFormV3ChildrenState = (currentFormV3El) => {
    const store = getStore();
    const { csrState } = storeToRefs(store);
    const currentFormV3ChildrenState = {};
    currentFormV3El.querySelectorAll(`.${__CLASS_CSR_CMP__}`).forEach((item) => {
        const { id } = item;
        currentFormV3ChildrenState[id] = csrState.value[id];
    });
    return currentFormV3ChildrenState;
}